/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import React, {useEffect, useState} from "react";

const useGeneralEditVideoForm = (selectedVideo, editedVideoRef) => {

    // Editable values (video values) - used to control the controlled elements' states
    const [association, setAssociation] = React.useState(selectedVideo?.basics?.association || '');
    const [discipline, setDiscipline] = React.useState(selectedVideo?.basics?.discipline || '');

    const [tournament, setTournament] = React.useState(selectedVideo?.basics?.tournament || '');
    const [year, setYear] = React.useState(selectedVideo?.basics?.year || '');
    const [ageGroup, setAgeGroup] = React.useState(selectedVideo?.basics?.ageGroup || '');
    const [gender, setGender] = React.useState(selectedVideo?.basics?.gender || '');
    const [surnameAthlete1, setSurnameAthlete1] = React.useState(selectedVideo?.basics?.surnameAthlete1 || '');
    const [surnameAthlete2, setSurnameAthlete2] = React.useState(selectedVideo?.basics?.surnameAthlete2 || '');
    const [bout, setBout] = React.useState(selectedVideo?.basics?.bout || '');

    // Video file state - will not be persisted (only the actual video and the resulting metadata)
    const [videoFile, setVideoFile] = useState(null);

    // If the some relevant state changes, also the reference needs to be updated
    useEffect(() => {
        editedVideoRef.current = {
            ...editedVideoRef.current,
            key: selectedVideo?.key,
            association: association,
            discipline: discipline,
            tournament: tournament,
            year: year,
            ageGroup: ageGroup,
            surnameAthlete1: surnameAthlete1,
            surnameAthlete2: surnameAthlete2,
            gender: gender,
            bout: bout,
            videoFile: videoFile
        }
    }, [association, discipline, tournament, year, ageGroup, surnameAthlete1, surnameAthlete2, gender, bout, videoFile])

    /*
    Functions for controlling the state of the controlled input elements.
    The state is updated on each value change / key stroke, this allows a flexible and dynamic handling.
     */

    const handleChangeAssociation = (event) => {
        setAssociation(event.target.value)

        // Also reset the discipline (otherwise there will be an exception in case of association change - as the selected value would be invalid)
        setDiscipline('')
        setBout('')
        setAgeGroup('')

        setTournament('')
        setSurnameAthlete1('')
        setSurnameAthlete2('')
    }

    const handleChangeDiscipline = (event) => {
        setDiscipline(event.target.value)
    }

    const handleChangeTournament = (value) => {
        setTournament(value)
    }

    const handleChangeYear = (event) => {
        setYear(event.target.value)
    }

    const handleChangeAgeGroup = (event) => {
        setAgeGroup(event.target.value)
    }

    const handleChangeGender = (event) => {
        setGender(event.target.value)
    }

    const handleChangeSurnameAthlete1 = (value) => {
        setSurnameAthlete1(value)
    }

    const handleChangeSurnameAthlete2 = (value) => {
        setSurnameAthlete2(value)
    }

    const handleChangeBout = (event) => {
        setBout(event.target.value)
    }

    const handleDropVideo = (acceptedFiles) => {
        setVideoFile(acceptedFiles[0])
    }

    return {
        association,
        discipline,
        tournament,
        year,
        ageGroup,
        gender,
        surnameAthlete1,
        surnameAthlete2,
        bout,

        videoFile,
        handleChangeAssociation,
        handleChangeDiscipline,
        handleChangeTournament,
        handleChangeYear,
        handleChangeAgeGroup,
        handleChangeGender,
        handleChangeSurnameAthlete1,
        handleChangeSurnameAthlete2,
        handleChangeBout,
        handleDropVideo
    }
}
export default useGeneralEditVideoForm;